import { secureApiPost, secureApiPut } from '../secureHttp';
import type { ScheduleType } from './list';

export type OneTimeSlotsInput = {
  date: string;
  ranges: Array<{ start_time: string; end_time: string }>;
  schedule_type?: ScheduleType;
};

export async function createOneTimeSlots(data: OneTimeSlotsInput) {
  return await secureApiPost(`/v1/psi-platform/psychologist/calendar/one-time-slots`, data);
}

export async function updateOneTimeSlots(data: OneTimeSlotsInput) {
  return await secureApiPut(`/v1/psi-platform/psychologist/calendar/one-time-slots`, data);
}
